<template>
  <!-- 空状态-组件 -->
  <div class="null-block flex">
    <i class="el-icon-tickets icons" />
    <p class="txt">{{ msgTxt }}</p>
  </div>
</template>

<script>
export default {
  name: 'NullCustom',

  props: {
    msgTxt: {
      type: String,
      default: '暂无相关摘要记录'
    }
  }
}
</script>

<style scoped lang="scss">
@import "./index.scss";
</style>
